module.exports.seq = require("./Sequence");
module.exports.seqcol = require("./SeqCollection");
module.exports.feature = require("./Feature");
module.exports.featurecol = require("./FeatureCol");



// WEBPACK FOOTER //
// ./src/model/index.js